/**
 * Tool bar configuration for CKEditor custom build
 */
export default {
  toolbar: {
    items: [
      'undo', 'redo',
      '|', 'heading',
      '|', 'bold', 'italic',
      '|', 'link', 'insertTable', 'blockQuote', 'mediaEmbed',
      '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
      '|', 'aiCommands', 'aiAssistant',
    ]
  },
  image: {
    toolbar: [
      'imageStyle:inline',
      'imageStyle:block',
      'imageStyle:side',
      '|',
      'toggleImageCaption',
      'imageTextAlternative'
    ]
  },
  table: {
    contentToolbar: [
      'tableColumn',
      'tableRow',
      'mergeTableCells'
    ]
  }
};
